import { Link } from "@inertiajs/react";

export default function AuditsEmptyState() {
  return (
    <div className="card flex min-h-52 items-center justify-center">
      <div className="card-body mb-8 flex flex-col items-center pt-0 text-center">
        <img
          src="/images/tasks_empty_state.png"
          alt="No audits illustration"
          className="mx-auto aspect-square w-full max-w-80 opacity-90"
        />
        <p className="mb-3 text-2xl font-semibold opacity-80">No audits yet</p>
        <p className="mx-auto mb-4 max-w-md text-lg opacity-60">
          Audits appear here after we evaluate pages on your domains, or when you run a page audit.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link href="/audits/new" className="btn btn-primary">
            Run page audit
          </Link>
          <Link href="/domains" className="btn">
            Go to domains
          </Link>
        </div>
      </div>
    </div>
  );
}
